// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import Moment from 'moment';
import { AppUpsell } from 'component-library';
import PageHeader from '../../components/Navigation/PageHeader/PageHeader';
import PositionFilter from './Filters/PositionFilter';
import BookFilter from './Filters/BookFilter';
import ResultFilter from './Filters/ResultFilter';
import StatFilter from './Filters/StatFilter';
import PlayerFilter from './Filters/PlayerFilter';
import PlayerProps from './PlayerProps/PlayerProps';
import SportEvents from './Teams/SportEvents';
import Teams from './Teams/Teams';
import PropsResults from './PlayerProps/PropsResults';
import PlayerCard from './PlayerCard/PlayerCard';
import { getPropsForSport } from '../../redux/actions/props';
import { getPropsResults } from '../../redux/actions/propsResults';
import { getSportEvents } from '../../redux/actions/sportevents';
import { getTeamsByDateRange } from '../../redux/actions/teams';
import { getUserDetails } from '../../redux/actions/userDetails';
import './Main.css';
import 'react-datepicker/dist/react-datepicker.css';
import FantasyLabsService from '../../services/fantasyLabsService';

// header

type Props = {
    match: { [key: string]: any },
    cookies: { [key: string]: any },
    match: { [key: string]: any },
    userDetails: { [key: string]: any },
    playerProps: { [key: string]: any },
    sportEvents: { [key: string]: any },
    propsResults: { [key: string]: any },
    teams: { [key: string]: any },
    sources: { [key: string]: any },
    getUserDetails: Function,
    getPropsForSport: Function,
    getSportEvents: Function,
    getTeamsByDateRange: Function,
    getPropsResults: Function
};

type State = {
    loginCookie: string,
    fromDate: Date,
    toDate: Date,
    mainView: string,
    showAllPlayers: boolean,
    showTeamFilter: boolean,
    showResultsView: boolean,
    sortPlayers: string,
    sortDirection: string,
    viewOwnerId: number,
    positionFilter: string,
    statFilter: string,
    bookFilter: string,
    resultFilter: string,
    playerFilter: string,
    teamFilter: string,
    playerCardOpen: boolean,
    playerCardPlayer: null,
    height: number,
    minDate: Date,
    maxDate: Date
};

class Main extends Component<Props, State> {
    fantasyLabsService = new FantasyLabsService();

    constructor(props) {
        super(props);

        const { cookies } = this.props;
        let viewStartDate = this.props.match.params.start_date;
        let viewEndDate = this.props.match.params.end_date;

        if (viewStartDate === '0' || viewEndDate === '0' || viewStartDate === undefined || viewEndDate === undefined) {
            const startDate = Moment().format('YYYYMMDD');
            let endDate = Moment().format('YYYYMMDD');

            if (this.props.match.params.sport.toLowerCase() === 'nfl') {
                const diff = Moment().day() - 1;
                if (diff < 0) {
                    endDate = Moment()
                        .add(1, 'days')
                        .format('YYYYMMDD');
                } else if (diff > 0) {
                    endDate = Moment()
                        .add(7 - diff, 'days')
                        .format('YYYYMMDD');
                }
            }
            document.location.href =
                '/apps/propositions/' + this.props.match.params.sport + '/' + startDate + '/' + endDate + '/';
        } else {
            viewStartDate = Moment(viewStartDate);
            viewEndDate = Moment(viewEndDate);
        }
        this.state = {
            loginCookie: cookies.get('flid') || this.fantasyLabsService.getSISessionToken() || '0',
            fromDate: viewStartDate,
            toDate: viewEndDate,
            mainView: 'lineups',
            showAllPlayers: true,
            showTeamFilter: false,
            showResultsView: true,
            sortPlayers: 'BetQuality',
            sortDirection: 'desc',
            viewOwnerId: 0,
            positionFilter: '',
            statFilter: '',
            bookFilter: '',
            resultFilter: '',
            playerFilter: '',
            teamFilter: '',
            playerCardOpen: false,
            playerCardPlayer: null,
            height: window.innerHeight - 155 - 88,
            minDate: viewStartDate,
            maxDate: Moment()
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.toggleAllPlayers = this.toggleAllPlayers.bind(this);
        this.handlePlayerSort = this.handlePlayerSort.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.togglePlayerCard = this.togglePlayerCard.bind(this);
        this.handleTeamFilterClick = this.handleTeamFilterClick.bind(this);
        this.handleResultsViewClick = this.handleResultsViewClick.bind(this);
    }
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    handleDateChange: (Date, Date, string) => void;
    toggleAllPlayers: () => void;
    handlePlayerSort: () => void;
    handleFilterChange: () => void;
    togglePlayerCard: () => void;
    handleTeamFilterClick: () => void;
    handleResultsViewClick: () => void;

    handleDateChange(startDate, endDate, changed) {
        if (startDate > endDate) {
            if (changed === 'start') {
                endDate = startDate;
            } else {
                startDate = endDate;
            }
        }
        document.location.href =
            '/apps/propositions/' +
            this.props.match.params.sport +
            '/' +
            Moment(startDate).format('YYYYMMDD') +
            '/' +
            Moment(endDate).format('YYYYMMDD') +
            '/';
    }

    toggleAllPlayers() {
        this.setState({
            showAllPlayers: !this.state.showAllPlayers
        });
    }

    handlePlayerSort(sort) {
        let direction = 'desc';
        if (sort === this.state.sortPlayers) {
            if (this.state.sortDirection === 'desc') {
                direction = 'asc';
            }
        }
        this.setState({
            sortPlayers: sort,
            sortDirection: direction
        });
    }

    handleFilterChange(e, name) {
        const values = e;

        if (name === 'Position') {
            if (values === '') {
                this.setState({
                    positionFilter: ''
                });
            } else {
                this.setState({
                    positionFilter: values.split(',')
                });
            }
        }
        if (name === 'Stat') {
            if (values === '') {
                this.setState({
                    statFilter: ''
                });
            } else {
                this.setState({
                    statFilter: values.split(',')
                });
            }
        }
        if (name === 'Book') {
            if (values === '') {
                this.setState({
                    bookFilter: ''
                });
            } else {
                this.setState({
                    bookFilter: values.split(',')
                });
            }
        }
        if (name === 'Result') {
            if (values === '') {
                this.setState({
                    resultFilter: ''
                });
            } else {
                this.setState({
                    resultFilter: values.split(',')
                });
            }
        }
        if (name === 'Player') {
            if (values.target.value === '') {
                this.setState({
                    playerFilter: ''
                });
            } else {
                this.setState({
                    playerFilter: values.target.value.split(',')
                });
            }
        }
        if (name === 'Team') {
            this.setState({
                teamFilter: values
            });
        }
    }

    togglePlayerCard(player) {
        this.setState({
            playerCardOpen: !this.state.playerCardOpen,
            playerCardPlayer: player
        });
    }

    clickPlayerCard(event) {
        event.stopPropagation();
    }

    handleTeamFilterClick() {
        this.setState({
            showTeamFilter: !this.state.showTeamFilter
        });
    }

    handleResultsViewClick() {
        this.setState({
            showResultsView: !this.state.showResultsView,
            height: this.state.showResultsView === true ? this.state.height + 189 : this.state.height - 189
        });
    }

    getSportId() {
        switch (this.props.match.params.sport) {
            case 'nfl':
                return 1;
            case 'nba':
                return 2;
            case 'mlb':
                return 3;
            case 'nhl':
                return 4;
            case 'pga':
                return 5;
            default:
                return 1;
        }
    }

    addDefaultSrc(ev) {
        ev.target.src = 'https://dpyukwfjby8ty.cloudfront.net/headshots/nhl/low-res/0_90x90.png';
    }

    componentDidMount() {
        let minDate = Moment(this.state.minDate);
        let maxDate = Moment(this.state.maxDate);
        const sportId = this.getSportId();

        this.props.getUserDetails(this.state.loginCookie);
        this.props.getPropsForSport(
            this.state.loginCookie,
            sportId,
            this.props.match.params.sport,
            this.state.fromDate,
            this.state.toDate
        );
        this.props.getSportEvents(this.state.loginCookie, sportId, this.props.match.params.sport, this.state.fromDate);
        this.props.getTeamsByDateRange(
            this.state.loginCookie,
            sportId,
            this.props.match.params.sport,
            this.state.fromDate,
            this.state.toDate
        );
        this.props.getPropsResults(
            this.state.loginCookie,
            sportId,
            this.props.match.params.sport,
            this.state.fromDate,
            this.state.toDate,
            '',
            '',
            '',
            '',
            '',
            '',
            ''
        );

        if (sportId === 1) {
            minDate = Moment('2017-10-05');

            const diff = Moment().day() - 1;
            if (diff < 0) {
                maxDate = Moment().add(1, 'days');
            } else if (diff > 0) {
                maxDate = Moment().add(7 - diff, 'days');
            }
        } else if (sportId === 2) {
            minDate = Moment('2017-10-17');
        } else if (sportId === 3) {
            minDate = Moment('2018-03-30');
        } else if (sportId === 4) {
            minDate = Moment('2018-10-03');
        }

        this.setState({
            minDate: minDate,
            maxDate: maxDate
        });
    }

    componentDidUpdate(previousProps, previousState) {
        if (previousState.fromDate !== this.state.fromDate || previousState.toDate !== this.state.toDate) {
            this.props.getPropsForSport(
                this.state.loginCookie,
                this.getSportId(),
                this.props.match.params.sport,
                this.state.fromDate,
                this.state.toDate
            );
            this.props.getSportEvents(
                this.state.loginCookie,
                this.getSportId(),
                this.props.match.params.sport,
                this.state.fromDate
            );
            this.props.getTeamsByDateRange(
                this.state.loginCookie,
                this.getSportId(),
                this.props.match.params.sport,
                this.state.fromDate,
                this.state.toDate
            );
            this.props.getPropsResults(
                this.state.loginCookie,
                this.getSportId(),
                this.props.match.params.sport,
                this.state.fromDate,
                this.state.toDate,
                '',
                '',
                '',
                '',
                '',
                '',
                ''
            );
        }
        if (
            previousState.positionFilter !== this.state.positionFilter ||
            previousState.statFilter !== this.state.statFilter ||
            previousState.bookFilter !== this.state.bookFilter ||
            previousState.playerFilter !== this.state.playerFilter ||
            previousState.teamFilter !== this.state.teamFilter
        ) {
            this.props.getPropsResults(
                this.state.loginCookie,
                this.getSportId(),
                this.props.match.params.sport,
                this.state.fromDate,
                this.state.toDate,
                !!this.state.teamFilter ? this.state.teamFilter.toString() : '',
                '',
                !!this.state.positionFilter ? this.state.positionFilter.toString() : '',
                !!this.state.statFilter ? this.state.statFilter.toString() : '',
                !!this.state.bookFilter ? this.state.bookFilter.toString() : '',
                !!this.state.playerFilter ? this.state.playerFilter.toString() : '',
                ''
            );
        }
    }

    render() {
        const heightOffset = this.fantasyLabsService.isSportsInsights() ? 153 : 0;
        const hostname = window && window.location && window.location.hostname;
        const playerPropsHeight =
            Moment(this.state.fromDate).format('YYYYMMDD') < Moment().format('YYYYMMDD')
                ? this.state.height - 222 + heightOffset
                : this.state.height + heightOffset;

        if (
            this.props.userDetails.userLoaded &&
            !this.props.userDetails.isPaid &&
            hostname.indexOf('qa') === -1 &&
            hostname.indexOf('localhost') === -1
        ) {
            document.location.href = '/pricing/upgrade-lite/';
        }

        const pageContent = (
            <div>
                <div className={'row row-no-margins filters-div'}>
                    <div
                        className={'media-right'}
                        style={{ paddingTop: '2px', width: '100%', display: 'inline-block' }}
                    >
                        <div style={{ display: 'inline-block', paddingRight: '10px', float: 'left' }}>
                            <span>Start Date</span>
                            <DatePicker
                                id={'select-start-date'}
                                selected={this.state.fromDate}
                                onChange={e => this.handleDateChange(e, this.state.toDate, 'start')}
                                className={'form-control-datepicker Select-control'}
                                minDate={this.state.minDate}
                                maxDate={this.state.maxDate}
                            />
                        </div>
                        <div style={{ display: 'inline-block', paddingRight: '10px', float: 'left' }}>
                            <span>End Date</span>
                            <DatePicker
                                id={'select-end-date'}
                                selected={this.state.toDate}
                                onChange={e => this.handleDateChange(this.state.fromDate, e, 'end')}
                                className={'form-control-datepicker Select-control'}
                                minDate={this.state.minDate}
                                maxDate={this.state.maxDate}
                            />
                        </div>
                        {this.props.match.params.sport === 'mlb' ? null : (
                            <div
                                style={{ display: 'inline-block', paddingRight: '10px', width: '250px', float: 'left' }}
                            >
                                <PositionFilter
                                    id={'select-position'}
                                    handleFilterChange={this.handleFilterChange}
                                    results={this.props.playerProps}
                                    values={this.state.positionFilter}
                                    removeSelected={true}
                                    disabled={false}
                                    stayOpen={false}
                                    rtl={false}
                                />
                            </div>
                        )}
                        {this.props.match.params.sport === 'mlb' ? null : (
                            <div
                                style={{ display: 'inline-block', paddingRight: '10px', width: '250px', float: 'left' }}
                            >
                                <StatFilter
                                    id={'select-stat'}
                                    handleFilterChange={this.handleFilterChange}
                                    results={this.props.playerProps}
                                    values={this.state.statFilter}
                                    removeSelected={true}
                                    disabled={false}
                                    stayOpen={false}
                                    rtl={false}
                                />
                            </div>
                        )}
                        <div style={{ display: 'none', paddingRight: '10px', width: '275px', float: 'left' }}>
                            <BookFilter
                                id={'select-book'}
                                handleFilterChange={this.handleFilterChange}
                                results={this.props.playerProps}
                                values={this.state.bookFilter}
                                removeSelected={true}
                                disabled={false}
                                stayOpen={false}
                                rtl={false}
                            />
                        </div>

                        {Moment(this.state.fromDate).format('YYYYMMDD') < Moment().format('YYYYMMDD') ? (
                            <div
                                style={{ display: 'inline-block', paddingRight: '10px', width: '225px', float: 'left' }}
                            >
                                <ResultFilter
                                    id={'select-result'}
                                    handleFilterChange={this.handleFilterChange}
                                    results={this.props.playerProps}
                                    values={this.state.resultFilter}
                                    removeSelected={true}
                                    disabled={false}
                                    stayOpen={false}
                                    rtl={false}
                                />
                            </div>
                        ) : null}

                        <div style={{ display: 'inline-block', paddingRight: '10px', float: 'left' }}>
                            <span>Player</span>
                            <PlayerFilter
                                id={'search-player'}
                                value={this.state.playerFilter}
                                handleFilterChange={this.handleFilterChange}
                            />
                        </div>

                        <div
                            style={{ display: 'inline-block', paddingRight: '10px', marginTop: '25px', float: 'right' }}
                        >
                            <button className="btn btn-link" onClick={() => this.handleTeamFilterClick()}>
                                <i className="fa fa-filter" />
                                Filter Teams
                            </button>
                        </div>
                    </div>
                </div>
                <div />
                <div className={'row row-no-margins'}>
                    <div
                        style={{
                            display:
                                this.state.showTeamFilter === true &&
                                ((Moment(this.state.fromDate).format('YYYYMMDD') ===
                                    Moment(this.state.toDate).format('YYYYMMDD') &&
                                    this.props.match.params.sport !== 'nfl') ||
                                    (Moment(this.state.fromDate)
                                        .add('days', 4)
                                        .format('YYYYMMDD') >= Moment(this.state.toDate).format('YYYYMMDD') &&
                                        this.props.match.params.sport === 'nfl'))
                                    ? 'block'
                                    : 'none',
                            paddingRight: '10px'
                        }}
                    >
                        <SportEvents
                            sportEvents={this.props.sportEvents}
                            teamFilter={this.state.teamFilter}
                            handleTeamFilterClick={this.handleTeamFilterClick}
                            handleFilterChange={this.handleFilterChange}
                        />
                    </div>
                    <div
                        style={{
                            display:
                                this.state.showTeamFilter === true &&
                                ((Moment(this.state.fromDate).format('YYYYMMDD') !==
                                    Moment(this.state.toDate).format('YYYYMMDD') &&
                                    this.props.match.params.sport !== 'nfl') ||
                                    (Moment(this.state.fromDate)
                                        .add('days', 4)
                                        .format('YYYYMMDD') < Moment(this.state.toDate).format('YYYYMMDD') &&
                                        this.props.match.params.sport === 'nfl'))
                                    ? 'block'
                                    : 'none',
                            paddingRight: '10px'
                        }}
                    >
                        <Teams
                            teams={this.props.teams}
                            teamFilter={this.state.teamFilter}
                            handleTeamFilterClick={this.handleTeamFilterClick}
                            handleFilterChange={this.handleFilterChange}
                        />
                    </div>
                    <div
                        className={'results-view'}
                        style={{
                            display:
                                Moment(this.state.fromDate).format('YYYYMMDD') < Moment().format('YYYYMMDD')
                                    ? 'block'
                                    : 'none',
                            height: this.state.showResultsView ? '210px' : '30px'
                        }}
                    >
                        <PropsResults
                            propsResults={this.props.propsResults}
                            handleResultsViewClick={this.handleResultsViewClick}
                            showResultsView={this.state.showResultsView}
                        />
                    </div>
                    <div className={'props-grid-container'}>
                        <div className={'props-grid'} style={{ height: playerPropsHeight + 'px' }}>
                            <PlayerProps
                                addDefaultSrc={this.addDefaultSrc}
                                showAllPlayers={this.state.showAllPlayers}
                                toggleAllPlayers={this.toggleAllPlayers}
                                handlePlayerSort={this.handlePlayerSort}
                                sortPlayers={this.state.sortPlayers}
                                sortDirection={this.state.sortDirection}
                                togglePlayerCard={this.togglePlayerCard}
                                playerProps={this.props.playerProps}
                                isPast={Moment(this.state.fromDate).format('YYYYMMDD') < Moment().format('YYYYMMDD')}
                                positionFilter={this.state.positionFilter}
                                statFilter={this.state.statFilter}
                                bookFilter={this.state.bookFilter}
                                resultFilter={this.state.resultFilter}
                                playerFilter={this.state.playerFilter}
                                teamFilter={this.state.teamFilter}
                                sport={this.props.match.params.sport}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

        const upsell = this.fantasyLabsService.isSportsInsights() ? pageContent : <AppUpsell page={'propositions'} />;

        return (
            <React.Fragment>
                <PageHeader
                    title={'Propositions'}
                    sport={this.props.match.params.sport}
                    sourceId={this.props.match.params.source_id}
                    sources={this.props.sources}
                />
                <div className="view-header-primary-right">
                    <div right="">
                        <a
                            className="btn btn-support"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="http://www.fantasylabs.com/fantasy-labs-player-props-tutorial"
                        >
                            <i className="fas fa-video" /> Getting Started
                        </a>
                    </div>
                </div>
                <div id={'appUpsellDiv'}>{upsell}</div>
                <div className={'page-content'}>{pageContent}</div>
                <PlayerCard
                    show={this.state.playerCardOpen}
                    onClose={this.togglePlayerCard}
                    player={this.state.playerCardPlayer}
                    sport={this.props.match.params.sport}
                    clickPlayerCard={this.clickPlayerCard}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        userDetails: state.userDetails,
        sports: state.sports.results,
        sources: state.sources.results,
        playerProps: state.playerProps,
        sportEvents: state.sportEvents,
        propsResults: state.propsResults,
        teams: state.teams
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getPropsForSport: (sessionId, sportId, sportName, startDate, endDate) =>
            dispatch(getPropsForSport(sessionId, sportId, sportName, startDate, endDate)),
        getSportEvents: (sessionId, sportId, sportName, eventDate) =>
            dispatch(getSportEvents(sessionId, sportId, sportName, eventDate)),
        getTeamsByDateRange: (sessionId, sportId, sportName, startDate, endDate) =>
            dispatch(getTeamsByDateRange(sessionId, sportId, sportName, startDate, endDate)),
        getPropsResults: (
            sessionId,
            sportId,
            sportName,
            startDate,
            endDate,
            teamId,
            oppTeamId,
            position,
            statId,
            sportsbook,
            playerName,
            side
        ) =>
            dispatch(
                getPropsResults(
                    sessionId,
                    sportId,
                    sportName,
                    startDate,
                    endDate,
                    teamId,
                    oppTeamId,
                    position,
                    statId,
                    sportsbook,
                    playerName,
                    side
                )
            ),
        getUserDetails: sessionId => dispatch(getUserDetails(sessionId))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withCookies(Main));



// WEBPACK FOOTER //
// ./src/components/Main/Main.js